/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  retryFailed(id) {
    return axios.post(`${this.url}/${id}/retry_failed`);
  }

  // Owner order 2026-09-29: stop a campaign that is already sending.
  stop(id) {
    return axios.post(`${this.url}/${id}/stop`);
  }

  // Owner order 2026-10-06: resume a campaign the circuit breaker paused.
  resumeMeta(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  getDeliveryRecipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/delivery_recipients`, { params });
  }

  downloadRecipients(id, status = 'all') {
    return axios.get(`${this.url}/${id}/download_recipients`, {
      params: { status },
      responseType: 'blob',
    });
  }

  downloadFailedRecipients(id) {
    return this.downloadRecipients(id, 'failed');
  }

  // Teletel: how many contacts the chosen labels reach (owner order 2026-09-14).
  // labelIds: contact labels; stageIds: lifecycle stages; dynamic: the
  // dynamic filter { entry_source, days, since, until, limit } (all optional).
  audiencePreview(labelIds, stageIds = [], dynamic = null) {
    return axios.get(
      `/teletel/api/v1/accounts/${this.accountIdFromRoute}/campaign-audience`,
      {
        params: {
          label_ids: labelIds,
          stage_ids: stageIds,
          ...(dynamic ? { dynamic } : {}),
        },
      }
    );
  }

  // Teletel: paste a list of numbers -> labelled contacts (audience in one step).
  // Teletel (campaign wizard 2026-09-25): a file of numbers -> labelled contacts.
  uploadAudience(file, label) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('label', label);
    return axios.post(
      `/teletel/api/v1/accounts/${this.accountIdFromRoute}/campaign-audience/upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  pasteAudience(numbers, label) {
    return axios.post(
      `/teletel/api/v1/accounts/${this.accountIdFromRoute}/campaign-audience/paste`,
      { numbers, label }
    );
  }

  syncDeliveryHistory() {
    return axios.post(`${this.url}/sync_delivery_history`);
  }
}

export default new CampaignsAPI();
